import { DatePipe, Location, CurrencyPipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ColDef, GridOptions } from 'ag-grid-community';

import { Insurance, RelatedInsurancePolicy } from '../../../common/models/financialAssurance.model';
import { Organization } from '../../../common/models/organization.model';
import { SubHeader } from '../../../core/models/sub-header.model';
import { CheckboxRendererComponent } from "../../../common/components/ag-grid/checkbox-renderer.component";
import { SubHeaderService } from '../../../core/services/sub-header.service';
import { OrganizationService } from '../../../common/services/organization.service';
import { dateComparator } from '../../../common/components/data-table/comparators/data-table.comparators';
import { GridFormatterService } from '../../../common/services/grid-formatter.service';
import { AgGridBooleanFilterComponent, IBooleanFilterParams } from '../../../common/components/ag-grid/filters/boolean-filter.component';

@Component({
    selector: 'app-fa-insurance-details',
    templateUrl: './fa-insurance-details.component.html',
    standalone: false
})
export class FaInsuranceDetailsComponent implements OnInit {



  colAmount: ColDef = {
      headerName: 'Amount',
      headerTooltip: 'Amount',
      valueGetter: this.insuranceAmountFormatter(this),
      tooltipValueGetter: this.insuranceAmountFormatter(this),
      maxWidth: 120
  };

  colEffective: ColDef = {
      headerName: 'Effective',
      headerTooltip: 'Effective',
      valueGetter: this.gridFormatterService.formatDate('effectiveDate'),
      tooltipValueGetter: this.gridFormatterService.formatDate('effectiveDate'),
      comparator: dateComparator,
      filter: "agDateColumnFilter",
      filterParams: this.gridFormatterService.defaultDateFilterParams,
      maxWidth: 125
  };

  colExpires: ColDef = {
      headerName: 'Expires',
      headerTooltip: 'Expires',
      valueGetter: this.gridFormatterService.formatDate('expirationDate'),
      tooltipValueGetter: this.gridFormatterService.formatDate('expirationDate'),
      comparator: dateComparator,
      filter: "agDateColumnFilter",
      filterParams: this.gridFormatterService.defaultDateFilterParams,
      maxWidth: 125
  };

  colPolicy: ColDef = {
      headerName: 'Policy Number',
      headerTooltip: 'Policy Number',
      field: 'policyNumber',
      tooltipField: 'policyNumber',
      maxWidth: 150
    };

  colType: ColDef = {
      headerName: 'Type',
      headerTooltip: 'Type',
      field: 'type',
      tooltipField: 'type',
      maxWidth: 150
  };

    colActive: ColDef = {
        headerName: 'Active',
        headerTooltip: 'Active',
        headerClass: "wrapped",
        cellStyle: { 'white-space': 'normal' },
        tooltipValueGetter: this.gridFormatterService.formatBooleanToYesNo('isActive'),
        cellRenderer: CheckboxRendererComponent,
        cellRendererParams: {
            action: () => { return false; },
            field: "isActive",
            description: "Active",
            isVisible: () => { return true; },
            isEnabled: () => { return false; },
            renderAsYesNo: true
        },
        field: 'isActive',
        filter: AgGridBooleanFilterComponent,
        filterParams: {
            isInServerSideFilterMode: false,
        } as IBooleanFilterParams,
        maxWidth: 100
    };

    colEnvironmentalEndorsement: ColDef = {
        headerName: 'Environmental Endorsement',
        headerTooltip: 'Environmental Endorsement',
        headerClass: "wrapped",
        cellStyle: { 'white-space': 'normal' },
        tooltipValueGetter: this.checkEnvironmentalEndorsementFlag(),
        valueFormatter: this.checkEnvironmentalEndorsementFlag(),
        valueGetter: this.hasEnvironmentalEndorsement(),
        field: "hasEnvironmentalEndorsement",
		filter: AgGridBooleanFilterComponent,
        filterParams: {
            isInServerSideFilterMode: false,
        } as IBooleanFilterParams,
        minWidth: 145,
        maxWidth: 145,
    };

    colReplacementApprovalDate: ColDef = {
        headerName: 'Replacement Approval',
        headerTooltip: 'Replacement Approval',
        headerClass: "wrapped",
        cellStyle: { 'white-space': 'normal' },
        valueGetter: this.gridFormatterService.formatDate('replacementApprovalDate'),
        tooltipValueGetter: this.gridFormatterService.formatDate('replacementApprovalDate'),
        comparator: dateComparator,
        filter: "agDateColumnFilter",
        filterParams: this.gridFormatterService.defaultDateFilterParams,
        maxWidth: 150
    };

    colReplacedByPolicyNumbers: any = {
        autoHeight: true,
        headerName: 'Replaced By Policy Numbers',
        headerTooltip: 'Replaced By Policy Numbers',
        headerClass: "wrapped",
        cellStyle: { 'white-space': 'normal' },
        valueGetter: this.policyNumberFormatter('replacedBy'),
        tooltipValueGetter: this.policyNumberFormatter('replacedBy'),
        filter: "agTextColumnFilter",
        filterParams: this.gridFormatterService.defaultTextFilterParams,
        maxWidth: 150
    };

    colReplacedPolicyNumbers: any = {
        autoHeight:true,
        headerName: 'Replacement Policy Numbers',
        headerTooltip: 'Replacement Policy Numbers',
        headerClass: "wrapped",
        cellStyle: { 'white-space': 'normal' },
        valueGetter: this.policyNumberFormatter('replacedPolicy'),
        tooltipValueGetter: this.policyNumberFormatter('replacedPolicy'),
        filter: "agTextColumnFilter",
        filterParams: this.gridFormatterService.defaultTextFilterParams,
        maxWidth: 150
    };

  gridOptions: GridOptions;
  insurance: Insurance;
  organization: Organization;

  subHeader = new SubHeader({
    title: "Insurance Details", buttons: [
      { name: "Back", method: () => this.back() }
    ]
  });

    public columnDefs = [
        this.colPolicy,
        this.colEffective,
        this.colExpires,
        this.colAmount,
        this.colType,
        this.colEnvironmentalEndorsement, 
        this.colActive,
        this.colReplacementApprovalDate,
        this.colReplacedByPolicyNumbers,
        this.colReplacedPolicyNumbers
    ];

  constructor(public currencyPipe: CurrencyPipe,
              public datePipe: DatePipe,
              public location: Location,
              public route: ActivatedRoute,
              public subHeaderService: SubHeaderService,
              public organizationService: OrganizationService,
      public gridFormatterService: GridFormatterService) {
  }

  ngOnInit() {

    this.subHeaderService.updateSubHeader(this.subHeader);
    this.insurance = this.route.snapshot.data.insurance;
    if (this.insurance) {
      this.organizationService.getOrganization(this.insurance.organizationId).subscribe(org => {
        this.organization = org;
      });
      }

      this.gridOptions = this.gridFormatterService.BuildDefaultGridOptionsWithColumns(this.columnDefs, false, true, true, true);
      this.gridOptions.headerHeight = 50;
      this.gridOptions.getRowClass = (params: any) => { if (!params.data.isActive) return 'red' };
  }

  back(): void {
    this.location.back()
  }

  public insuranceAmountFormatter(component) {
    return (obj) => component.currencyPipe.transform(obj.data.limit);
  }

  phoneFormatter(phone: string) {    
      if (!phone) return '';
      if (phone.length === 10) return phone.substr(0, 3) + '-' + phone.substr(3, 3) + '-' + phone.substr(6, 4);
      return phone;    
    }

    policyNumberFormatter(fieldName: string) {
        return (obj): string => {

            let policyNumbers = '';
            let relatedPolicies = obj.data[fieldName] as RelatedInsurancePolicy[];

            if (relatedPolicies) {
                let numberofRelatedPolicies = relatedPolicies.length;

                if (numberofRelatedPolicies > 0) {
                    for (let x = 0; x < numberofRelatedPolicies; x++) {
                        policyNumbers += relatedPolicies[x].policyNumber
                        if (x < numberofRelatedPolicies + -1)
                            policyNumbers += ', '
                    }
                }
            }
            return policyNumbers;
        }
    }

    public hasEnvironmentalEndorsement(): any {
        return (obj): boolean => {
            if (obj.data) {
                let hasEnvironmentalEndorsement = obj.data["hasEnvironmentalEndorsement"];
                let insuranceType = obj.data["type"];

                if (insuranceType == "Environmental")
                    return true;
                else
                    return hasEnvironmentalEndorsement;
            }
        }
    }

    public checkEnvironmentalEndorsementFlag(): any {
        return (obj) => {
            if (obj.data) {
                var path = "$.hasEnvironmentalEndorsement";
                let fieldValue = this.gridFormatterService.tryGetValue(obj.data, path);

                let insuranceType = obj.data["type"]

                if (insuranceType == "Environmental")
                    return 'Yes';

                if (fieldValue != undefined && fieldValue != null)
                    return fieldValue ? 'Yes' : 'No';
                else return "N/A";
            }
        }
    }

}
